const PercentSou = ({ viewBox, percentil, textos }) => {
	return (
		<foreignObject
			x={
				percentil > 90
					? viewBox.x - 72.88
					: percentil < 10
					? viewBox.x
					: viewBox.x - 36.44
			}
			y={viewBox.height / 2}
			width='100%'
			height='100%'
		>
			<div xmlns='http://www.w3.org/1999/xhtml' className='e6 percent-sou'>
				{textos.estas_aqui}
			</div>
		</foreignObject>
	)
}
export default PercentSou
